import {
  formatNumberToCurrency,
  formatRateToPercent,
  getChannelAcquiredCount,
  getChannelAcquisitionRate,
} from 'utils/app';

import type { JSX } from 'react';

/**
 * レポートの統計カード（5枚）
 * 参加数 / 獲得リスト数 / リスト獲得率 / 完了数 / 完了率
 * 獲得リスト数・リスト獲得率は lineFlag に応じてメール/LINEいずれか一方のみを表示する（チャネル排他）
 */
export default function WsReportMetrics(props: {
  participatedCount: number;
  lineFlag: boolean;
  mailAddressCount: number;
  lineCount: number;
  mailAddressAcquisitionRate: number;
  lineAddressAcquisitionRate: number;
  answeredCount: number;
  answeredRate: number;
}): JSX.Element {
  const {
    participatedCount,
    lineFlag,
    mailAddressCount,
    lineCount,
    mailAddressAcquisitionRate,
    lineAddressAcquisitionRate,
    answeredCount,
    answeredRate,
  } = props;

  return (
    <section className="section-statistical">
      <div className="container">
        <div className="row row-cols-1 row-cols-sm-2 row-cols-lg-5 row-report-statistical-metrics row-15-xl row-5-xl row-12-lg">
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>参加数</small>
                    {formatNumberToCurrency(participatedCount)}
                  </div>
                  <div className="flex-grow-1 flex-right">
                    <span className="img-body light-blue">
                      <img src="/img/icon/people.svg" alt="参加数" className="w-lg-26" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>獲得リスト数</small>
                    {formatNumberToCurrency(
                      getChannelAcquiredCount(lineFlag, mailAddressCount, lineCount)
                    )}
                  </div>
                  <div className="flex-grow-1 flex-right">
                    <span className="img-body light-yellow">
                      <img src="/img/icon/arrow.svg" alt="獲得リスト数" className="w-lg-26" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>リスト獲得率</small>
                    {`${formatRateToPercent(
                      getChannelAcquisitionRate(
                        lineFlag,
                        mailAddressAcquisitionRate,
                        lineAddressAcquisitionRate
                      )
                    )}%`}
                  </div>
                  <div className="flex-grow-1 flex-right">
                    <span className="img-body light-green">
                      <img src="/img/icon/chart.svg" alt="リスト獲得率" className="w-lg-23" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>完了数</small>
                    {formatNumberToCurrency(answeredCount)}
                  </div>
                  <div className="flex-grow-1 flex-right">
                    <span className="img-body light-violet">
                      <img src="/img/icon/tick.svg" alt="完了数" className="w-lg-23" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
          <div>
            <div className="card card-white">
              <div className="card-body">
                <div className="d-flex d-flex-statistical">
                  <div className="flex-shrink-0 flex-left">
                    <small>完了率</small>
                    {`${formatRateToPercent(answeredRate)}%`}
                  </div>
                  <div className="flex-grow-1 flex-right">
                    <span className="img-body light-pink">
                      <img src="/img/icon/oclock.svg" alt="完了率" className="w-lg-23" />
                    </span>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
